import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { qrConfigurationQueryOptions } from "@/lib/qr";
import { useQrSessionStore } from "@/stores/qr-session";

/**
 * Tells a QR guest which table they are ordering onto, on every page of the
 * flow. Worth the strip of screen: a phone that scanned the wrong sticker
 * otherwise sends food to the wrong table with nothing to warn anyone.
 */
export function QrTableBanner() {
  const { t } = useTranslation("translation");
  const session = useQrSessionStore((state) => state.session);

  const { data: configuration } = useQuery({
    ...qrConfigurationQueryOptions(),
    enabled: session !== undefined,
  });

  if (!session) return null;

  return (
    <div className="flex flex-col items-center gap-0.5 border-b bg-black/90 px-4 py-2 text-center text-white">
      <span className="font-semibold">
        {t("Qr.table_label", { reference: session.tableReference })}
        {session.sectionName ? ` - ${session.sectionName}` : ""}
      </span>
      {configuration?.welcomeMessage && (
        <span className="text-sm text-white/80">
          {configuration.welcomeMessage}
        </span>
      )}
    </div>
  );
}
